import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDHBY9VVGNKfldAYbwIPIq3Qpw1IlVPstA",
  authDomain: "clone-2bcd0.firebaseapp.com",
  databaseURL: "https://clone-2bcd0.firebaseio.com",
  projectId: "clone-2bcd0",
  storageBucket: "clone-2bcd0.appspot.com",
  messagingSenderId: "924890039638",
  appId: "1:924890039638:web:a279b541334787619102f7",
  measurementId: "G-22CQDL6SDF",
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth, firebaseApp };
